import React, { useRef } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import ReCAPTCHA from "react-google-recaptcha";
import Swal from "sweetalert2";

import { fetch } from "../../../utils/fetch";
import { RECAPTCHA } from "../../../utils/constants";

const validationSchema = Yup.object().shape({
  nombre: Yup.string().required("Campo obligatorio"),
  apellido: Yup.string().required("Campo obligatorio"),
  dni: Yup.string()
    .matches(/^[0-9]+$/, "El DNI solo debe contener números")
    .min(7, "El DNI debe tener entre 7 y 8 dígitos")
    .max(8, "El DNI debe tener entre 7 y 8 dígitos")
    .required("Campo obligatorio"),
  email: Yup.string().email("Email inválido").required("Campo obligatorio"),
  telefono: Yup.string().required("Campo obligatorio"),
});

const initialValues = {
  nombre: "",
  apellido: "",
  dni: "",
  email: "",
  telefono: "",
};

const LegadosContactoComponent = () => {
  const captcha = useRef(null);

  const onSubmit = async (values, resetForm) => {
    if (captcha.current?.getValue()) {
      try {
        const { data } = await fetch("legados/contacto", "post", {
          nombre: values.nombre,
          apellido: values.apellido,
          dni: values.dni,
          email: values.email,
          telefono: values.telefono,
        });

        resetForm();
        captcha.current?.reset();
        Swal.fire("Info!", data?.message || "Consulta enviada con éxito", "success");
      } catch (error) {
        captcha.current?.reset();
        Swal.fire(
          "Error",
          error?.response?.data?.message ||
            "Ocurrió un error al enviar la consulta. Intente nuevamente.",
          "error"
        );
      }
    } else {
      Swal.fire("Info!", "Debe indicar que no es un robot", "info");
    }
  };

  return (
    <div className="row mt-4" id="legados-contacto-container">
      <div className="col-12 col-lg-10 col-xl-8 mx-auto">
        <div className="card p-4 b-radius-10">
          <h3 style={{ color: "#05294F" }}>
            <strong>Dejanos tu consulta</strong>
          </h3>
          <hr />
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values, { resetForm }) => onSubmit(values, resetForm)}
          >
            {({ values, errors, handleChange, handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <div className="mb-3 row align-items-center">
                  <div className="col-lg-3">
                    <label>Nombre *</label>
                  </div>
                  <div className="col-lg-9">
                    <input
                      type="text"
                      name="nombre"
                      value={values.nombre}
                      onChange={handleChange}
                      className="form-control b-radius-20 shadow-blue"
                    />
                    <div className="text-danger text-danger-custom">{errors?.nombre}</div>
                  </div>
                </div>

                <div className="mb-3 row align-items-center">
                  <div className="col-lg-3">
                    <label>Apellido *</label>
                  </div>
                  <div className="col-lg-9">
                    <input
                      type="text"
                      name="apellido"
                      value={values.apellido}
                      onChange={handleChange}
                      className="form-control b-radius-20 shadow-blue"
                    />
                    <div className="text-danger text-danger-custom">{errors?.apellido}</div>
                  </div>
                </div>

                <div className="mb-3 row align-items-center">
                  <div className="col-lg-3">
                    <label>DNI *</label>
                  </div>
                  <div className="col-lg-9">
                    <input
                      type="text"
                      name="dni"
                      value={values.dni}
                      onChange={handleChange}
                      className="form-control b-radius-20 shadow-blue"
                    />
                    <div className="text-danger text-danger-custom">{errors?.dni}</div>
                  </div>
                </div>

                <div className="mb-3 row align-items-center">
                  <div className="col-lg-3">
                    <label>Mail *</label>
                  </div>
                  <div className="col-lg-9">
                    <input
                      type="email"
                      name="email"
                      value={values.email}
                      onChange={handleChange}
                      className="form-control b-radius-20 shadow-blue"
                    />
                    <div className="text-danger text-danger-custom">{errors?.email}</div>
                  </div>
                </div>

                <div className="mb-3 row align-items-center">
                  <div className="col-lg-3">
                    <label>Teléfono *</label>
                  </div>
                  <div className="col-lg-9">
                    <input
                      type="text"
                      name="telefono"
                      value={values.telefono}
                      onChange={handleChange}
                      className="form-control b-radius-20 shadow-blue"
                    />
                    <div className="text-danger text-danger-custom">{errors?.telefono}</div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-lg-12">
                    <div id="botCaptcha">
                      <ReCAPTCHA ref={captcha} sitekey={RECAPTCHA} />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-lg-12">
                    <div className="mt-3 mb-2">
                      <button type="submit" className="btn grandiend-btn b-radius-20 px-5">
                        Enviar
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default LegadosContactoComponent;
